import React, { useEffect } from 'react';
import LoadingAnimation from './LoadingAnimation';

import { Redirect } from 'react-router-dom';
import { useOvermind } from '../../overmind';

import {GoogleAPI,
        GetliveGTMpayload} from '../../utils/util-networkCalls.js';

import {SetWindowVars,
        TagDataTableArray,
        VariableDataTableArray,
        TriggerDataTableArray} from '../../utils/util-reformatingContainer';

import {StringifyNestedObjects} from '../../utils/util-JSONtools';

import * as Sentry from "@sentry/react";

export default function Loader() {
  const { state, actions } = useOvermind();

  useEffect(() => {
    actions.loadingDataFlag(true);
    if(typeof state.authState.googleAccessToken !== 'undefined'
       && typeof state.accountList !== 'undefined'
       && state.accountIndex !== null
       && typeof state.containerList !== 'undefined'
       && state.containerIndex !== null
     ){
       let containerObject = state.containerList[state.containerIndex];

       GoogleAPI(containerObject.path+'/versions:live',state.authState.googleAccessToken)
       .then(response =>{

         let tagDataTable = TagDataTableArray(response);
         let variableDataTable =VariableDataTableArray(response);
         let triggerDataTable = TriggerDataTableArray(response);
         let gtmPayload = GetliveGTMpayload(containerObject.publicId);

         //Data for Documentation and Explore
         actions.addFormattedData({'name':'liveContainerConfig', 'payload':response});
         actions.addFormattedData({'name':'tagDataTable', 'payload':TagDataTableArray(response)});
         actions.addFormattedData({'name':'variableDataTable', 'payload':VariableDataTableArray(response)});
         actions.addFormattedData({'name':'triggerDataTable', 'payload':TriggerDataTableArray(response)});

         // Data for Documentaton Donut recharts
         actions.addTagDonutChartData();
         actions.addTriggerDonutChartData();
         actions.addVariableDonutChartData();


         //Data for recommendations
         actions.getRecommendations();


         if (state.debug === true){
           console.log('Initial Loading state Logged')
           Sentry.setContext("Overmind Loader State Object", StringifyNestedObjects(state, ['authState'], ['liveContainerConfig','docDonutChart','recommendation','tagDataTable','triggerDataTable','variableDataTable'], false));
         }

         //actions.addFormattedData({'name':'gtmPayLoad', 'payload':GetliveGTMpayload(containerObject.publicId)});

         let cookiePayload = {"sid":state.authState.googleAccessToken,
                              "uid":state.authState,
                              "aid":state.accountIndex,
                              "alist":state.accountList,
                              "cid":state.containerIndex,
                              "clist":state.containerList
                            }
         let encodedPayload = btoa(JSON.stringify(cookiePayload));

         window.localStorage.setItem("sid", encodedPayload);
         //console.log(encodedPayload);
         //console.log(atob(encodedPayload));


         let windowData = {
                           "container":response,
                           "tagData": tagDataTable,
                           "variableData": variableDataTable,
                           "triggerData": triggerDataTable,
                           "gtmPayLoad": gtmPayload
                          };

         SetWindowVars(windowData,false);
         actions.loadingDataFlag(false);
         actions.setActiveStep(0);
       });
    }
  });

  if(state.loadingData){

      return (
        <LoadingAnimation/>
      );

  }else{

    return(<Redirect to='/get-started'/>);
  }
}
